import { useEffect, useMemo, useState } from 'react';
import { listStudentNotes, STUDENT_NOTES_UPDATED_EVENT } from './notesStore';
import type { RuntimeActorRole } from './types';

export function useStudentNotes(studentId: string, viewerRole: RuntimeActorRole) {
  const load = useMemo(() => () => listStudentNotes(studentId, viewerRole), [studentId, viewerRole]);
  const [notes, setNotes] = useState(load);

  useEffect(() => {
    const reload = () => setNotes(load());
    window.addEventListener('storage', reload);
    window.addEventListener(STUDENT_NOTES_UPDATED_EVENT, reload);
    return () => {
      window.removeEventListener('storage', reload);
      window.removeEventListener(STUDENT_NOTES_UPDATED_EVENT, reload);
    };
  }, [load]);

  return notes;
}
